// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TooltipPresentationProps } from "@ces/MobiusOverrides/Tooltip/Tooltip";
import Info from "@ces/XDL/Icons/Info";
import { xBaseTheme } from "@ces/XDL/types";
import { color, getSystemColor, styledScrollbar, xScreen } from "@ces/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

export default {
    defaultProps: {
        mergeCss: true,
        cssOverrides: {
            container: {
                css: css`
                    line-height: 0;
                `,
            },
            tooltipContainer: css`
                background-color: ${color("common.ui1")};
                box-shadow: 0 2px 4px 0 ${color("common.black", 0.1)};
                padding: 12px;
                max-width: 260px;
                border: 1px solid ${color("common.border")};
                border-radius: 6px;
                background-color: ${color("common.ui1")};
                min-width: 140px;

                &[data-placement^="top"] > .tippy-arrow {
                    bottom: -10px;
                    &:before {
                        transform: rotate(45deg);
                    }
                }

                &[data-placement^="bottom"] > .tippy-arrow {
                    top: -10px;
                    &:before {
                        transform: rotate(-135deg);
                    }
                }

                &[data-placement^="left"] > .tippy-arrow {
                    right: -10px;
                    &:before {
                        transform: rotate(-45deg);
                    }
                }

                &[data-placement^="right"] > .tippy-arrow {
                    left: -10px;
                    &:before {
                        transform: rotate(135deg);
                    }
                }

                .tippy-arrow,
                .tippy-arrow::before {
                    position: absolute;
                    width: 20px;
                    height: 20px;
                    z-index: 1;
                }

                .tippy-arrow::before {
                    content: "";
                    background: ${color("common.ui1")};
                    border-color: ${color("common.border")};
                    border-style: solid;
                    border-width: 0 1px 1px 0;
                    border-top-left-radius: 0;
                    border-top-right-radius: 0;
                    border-bottom-right-radius: 4px;
                    border-bottom-left-radius: 0px;
                }

                ${styledScrollbar({ width: 4 })}
            `,
            tooltipBody: css`
                display: flex;
                flex-direction: column;
                flex: 0 0 auto;
            `,
            tooltipClickable: css`
                margin-left: 5px;
                margin-right: 5px;
                &:hover {
                    ${IconWrapper} {
                        opacity: 1;
                    }
                }
            `,
            tooltipWrapper: css`
                ${xScreen("lte", "md")} {
                    div[data-tippy-root] {
                        display: flex;
                        justify-content: center;
                        width: max-content;
                        top: -15px !important;
                    }
                }
            `,
        } as TooltipPresentationProps,
        iconProps: {
            src: Info,
            size: 13,
            color: getSystemColor("common.ui7"),
            css: css`
                opacity: 0.66;
            `,
        },
        typographyProps: {
            size: 13,
            lineHeight: "20px",
            color: "text.main",
            weight: "normal",
            css: css`
                letter-spacing: 0;
                line-height: 20px;
                text-align: left;
                white-space: break-spaces;
                word-break: break-word;
                &:hover {
                    text-decoration: none;
                }
            `,
        },
    },
} as xBaseTheme["tooltip"];
